import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { Pill } from '../../components-v2/Pill';
import { styleSheet } from './styles';

interface IProps {
	selectedUserGroupIds: string[];
	allUserGroups: Api.IUserGroup[];
}

export const UserGroupPills = ({ selectedUserGroupIds, allUserGroups }: IProps) => {
	const userSession = useUserSession();
	const selectedUserGroups = allUserGroups?.filter(g => selectedUserGroupIds?.includes(g.id ?? g.name)) ?? [];

	return userSession.isAdmin && selectedUserGroups.length > 0 ? (
		<div className={css(styleSheet.userGroupsContainer)}>
			<span className={css(styleSheet.userGroupsLabel)}>Shared with:</span>
			{selectedUserGroups.map(group => (
				<Pill key={group.id ?? group.name} variant='tag' color='teal' label={group.name} />
			))}
		</div>
	) : null;
};
